import React, { Component } from 'react';
import RightSearchBar from '../components/RightSearchBar';
import MapCard from '../components/MapCard';
import Card from '../components/Card';
import SemanticTableHousing from '../components/SemanticTableHousing';
import Base from './Base';
import {Link } from "react-router-dom";
import UserStore from '../stores/UserStore';

require('dotenv').config()


class NewsAdminList extends Component {

  constructor() {
  super();
  this.state = {
       news: []
     }
      this.removeNewsFromList= this.removeNewsFromList.bind(this);
  }

  componentDidMount() {

    const requestOptions = {
	    crossDomain:true,
        method: 'GET',
        headers: { 'Content-Type': 'application/json' }
    };
    fetch(global.apiUrl +'/v0/news?access_token=' + UserStore.access_token, requestOptions)
    .then(res => res.json())
    .then((data) => {
        this.setState({ news: data['news']});
      })
    .catch(console.log);
  }

    /**
     * Remove news from list
     * @param id of news object
     */
    removeNewsFromList(newsId){
        let newsCopy = this.state.news;
        let newNewsList = [];
        for (var i = 0; i < newsCopy.length; i++) {
            let newsObject = (newsCopy[i]);
            console.log(newsObject)
            if(newsObject['id'] != newsId){
                newNewsList.push(newsObject)
            }
        }
        this.setState({ news: newNewsList});
    }

  render() {
      return (
        <Base pageTopic={"News admin list"} mainContent={ <>


            {this.state.news && this.state.news.map((row) =>
                <>
                    <Card title={row['headline']} body={
                        <div className="card-body">
                            <h6 className="card-subtitle mb-2 text-muted">{row['publish_date'].replace("T"," ")}</h6>
                            <h6 className="card-subtitle mb-2 text-muted">{row['type']}</h6>
                            {row['publish'] && <span class="badge badge-success">Published</span>}
                            {!row['publish'] && <span class="badge badge-warning">Not published</span>}
                            <p className="card-text">{row['summary']}</p>
                            <Link to={"/news/admin/edit/" + row['id']}><button type="button" class="btn btn-outline-warning"> Edit </button></Link>
                        </div>
                    }></Card>
                </>
            )}



          </>}
         ></Base>
	     )
  }
}

export default NewsAdminList;
